import(/* webpackMode: "eager" */ "/Users/andrejkazimov/Developer/Forecast/apps/miniapp/src/app/markets/page.tsx");
